<template>
  <div ref="roadRoot" class="bottom-cards" :class="{ 'expand-anim': inView }">
    <CardComponent
      v-for="(card, index) in cards"
      :key="index"
      :title="card.title"
      :description="card.description"
      :background="card.background"
      :links="card.links"
      :is-hovered="hoveredIndex === index"
      :is-other-hovered="hoveredIndex !== null && hoveredIndex !== index"
      :lang="lang"
      @mouseenter.native="hoveredIndex = index"
      @mouseleave.native="hoveredIndex = null"
    />
  </div>
</template>

<script>
import CardComponent from './CardComponent.vue';
import { mapState } from 'vuex';
import { esgCards } from '@/components/main_pages/skinc/skincData.js';

export default {
  name: 'BottomCards',
  components: { CardComponent },
  data() {
    return {
      hoveredIndex: null,
      inView: false
    };
  },
  computed: {
    ...mapState('report_list', ['lang']),
    cards() {
      const baseCards = esgCards;

      if (this.lang === 'ENG') {
        return baseCards.map(card => ({
          ...card,
          description: card.description_e,
          links: card.links.map(link => ({
            ...link,
            text: link.text_e
          }))
        }));
      }

      return baseCards;
    }
  },
  mounted() {
    const observer = new IntersectionObserver(([entry], obs) => {
      if (entry.isIntersecting) {
        this.inView = true;
        obs.disconnect();
      }
    });
    observer.observe(this.$refs.roadRoot);
  }
};
</script>

<style scoped>
.bottom-cards {
  display: flex;
  width: 100%;
  height: 1px;
  overflow: hidden;
  position: relative;
  top: 0;
  justify-content: space-between;
  gap: 0;
  flex-wrap: nowrap;
  padding: 0;
  transition: height 1.2s ease 0.6s;
}

.bottom-cards.expand-anim {
  height: calc(100vh - 90px);
}

@media (max-width: 768px) {
  .bottom-cards {
    flex-direction: column;
  }

  .bottom-cards.expand-anim {
    height: auto;
    padding: 20px 0;
  }

  .bottom-cards > * {
    min-height: 400px;
  }
}
</style>
